export default __webpack_public_path__ + "static/media/sync.7e547a99.svg";